import { forwardRef } from "react";

import {
  fieldLabelVariants,
  type FieldLabelVariants,
} from "./field-label.styles";

export type FieldLabelRef = React.ComponentRef<"label">;

export interface FieldLabelProps
  extends React.ComponentPropsWithoutRef<"label">, FieldLabelVariants {
  htmlFor?: string;
}

const FieldLabel = forwardRef<FieldLabelRef, FieldLabelProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <label {...props} className={fieldLabelVariants({ className })} ref={ref}>
        {children}
      </label>
    );
  },
);

FieldLabel.displayName = "FieldLabel";

export { FieldLabel, FieldLabel as Label };
